module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/059128109f4c99fd85668e22fefb7b4f.png";